import { useEffect, useRef, useState } from "react";
import { type AlertProps, Alert as BsAlert } from "react-bootstrap";
import { type Alert, AlertType, useAlertSubscribe } from "./Alert";

const variantType: Record<AlertType, AlertProps["variant"]> = {
	[AlertType.ERROR]: "danger",
	[AlertType.INFO]: "info",
	[AlertType.SUCCESS]: "success",
	[AlertType.WARNING]: "warning",
};

export const AlertMessage = () => {
	const [alert, setAlert] = useState<Alert>();
	const ref = useRef<HTMLDivElement | null>(null);

	useAlertSubscribe((alert) => {
		setAlert(alert);
	});

	useEffect(() => {
		if (alert) {
			ref.current?.scrollIntoView({ behavior: "smooth" });
		}
	}, [alert]);

	if (!alert) {
		return null;
	}

	return (
		<BsAlert
			variant={variantType[alert.type]}
			onClose={() => setAlert(undefined)}
			dismissible
			ref={ref}
			style={{ scrollMarginTop: "3rem" }}
		>
			{alert.content}
		</BsAlert>
	);
};
